<template>
  <form class="form-horizontal">
    <div class="form-group">
      <label class="col-xs-1 control-label">
        标题
      </label>
      <div class="col-xs-8">
        <input type="text" class="form-control" v-model="route.basic.scheduleTitle">
      </div>
    </div>
    <div v-d-sortable="route.routeSchedule">
      <div class="form-group" v-for="item in route.routeSchedule" track-by="$index">
        <label class="col-xs-1 control-label">
          {{$index + 1}}
        </label>
        <div class="col-xs-8">
          <div class="input-group">
            <input type="text" class="form-control" v-model="item.intro">
            <span class="input-group-addon" @click="route.routeSchedule.$remove(item)">&times;</span>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="col-xs-12 text-center">
        <button type="button" class="btn btn-default" @click="route.routeSchedule.push({intro: ''})">添加</button>
      </div>
    </div>
    <div class="form-group">
      <div class="col-xs-12 text-center">
        <button @click="click(submit)($event)" type="button" class="btn btn-primary">保存</button>
        <button @click="click(submit)($event, '/route/' + $route.params.id + '/focus')" type="button" class="btn btn-success">保存并下一步</button>
      </div>
    </div>
  </form>
</template>
<script>
  import utils from '../../libs/utils'
  import config from '../../libs/config'

  export default {
    props: ['route'],
    methods: {
      submit (next) {
        let routeId = this.$route.params.id
        let routeSchedules = this.route.routeSchedule.map(({intro}, index) => {
          return {
            intro,
            order: index
          }
        })
        let data = {
          scheduleTitle: this.route.basic.scheduleTitle,
          routeSchedules
        }
        return this.$http.put(`${config.apiWe}/product/route/${routeId}/schedule`, data)
          .then(() => {
            next && this.$route.router.go(next)
          })
      },
      dragSort (e) {
        utils.dragSort(this.route.routeSchedule)(e)
      },
      click: utils.click
    }
  }
</script>



/** WEBPACK FOOTER **
 ** Itinerary.vue?60253b5a
 **/